export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywacja czeku elektronicznego"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rachunek depozytowy"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seria"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod aktywacyjny"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprawdzać"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywuj"])}
}